module.exports = __webpack_public_path__ + "static/img/gov1.84ec24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client_logo/gov1.png
// module id = Fa/e
// module chunks = 0